import { IConfigData } from '@df/catalog/config/config.interfaces';
import { Model, TLoadParams } from '@df/catalog/model';
import { Resource } from '@df/catalog/resource';
import { Nexus } from '@tomandco/nexus-api-types';

declare module '@df/catalog/resource' {
    interface IResources {
        config: ConfigResource;
    }
}

export interface IConfigModel<TContent = any> extends Model<IConfigData<TContent>, number> {}

export abstract class ConfigResource<T extends IConfigModel = IConfigModel> extends Resource<T, number> {
    readonly invalidatesUniversal = true;
    readonly invalidatesPrerender = false;

    /**
     * Loads item by entry id
     */
    loadModelByUrl(entryId: string, params?: Partial<TLoadParams>): Promise<T | undefined> {
        return this.findOne({ filter: { url: entryId }, verbosity: 1 }, params);
    }

    /**
     * Finds config by its url
     */
    getModelByUrl(entryId: string): T | undefined {
        return this.getAllExisting().find(i => i.data?.url === entryId);
    }

    /**
     * Loads countries list (passed from magento)
     */
    loadCountries(): Promise<Model<IConfigData<Nexus.Lib.General.Country[]>> | undefined> {
        return this.loadModelByUrl('appCountries');
    }
}
